var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 4.175 6.675 3.5 7.5 3.5H31.5C32.325 3.5 33 2.825 33 2C33 1.175 32.325 0.5 31.5 0.5H6C4.35 0.5 3 1.85 3 3.5V20H2.25C1.005 20 0 21.005 0 22.25C0 23.495 1.005 24.5 2.25 24.5H21V20H6V5ZM34.5 6.5H25.5C24.675 6.5 24 7.175 24 8V23C24 23.825 24.675 24.5 25.5 24.5H34.5C35.325 24.5 36 23.825 36 23V8C36 7.175 35.325 6.5 34.5 6.5ZM33 20H27V9.5H33V20Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.c9b25d91c4b4439f6f19aaf413349c50.svg";
export { ForwardRef as ReactComponent };